export default __webpack_public_path__ + "static/media/arrow-up.b1ae2213.svg";